import { useMutation } from "@tanstack/react-query";
import { AITerms } from "@graylog/enterprise-api";
const useAcceptAITerms = (onConsent) => {
  const { mutateAsync } = useMutation({
    mutationFn: (version) => AITerms.addConsent(version),
    onSuccess: onConsent
  });
  return mutateAsync;
};
export default useAcceptAITerms;
